import React from 'react';

//const PosContentsProduct = ({idx, products}) =>{
const PosContentsProduct = ({product, setProduct}) =>{

    const chkQuantity = (e) => {
        console.log(e.target.value);
    }

    const textPosition = "right";
    //console.log("idx", idx);
    if(false){
    return(
        <tr key={product.productIdx}>
        <th scope="row">{product.productIdx}{/*idx+1*/}</th>
        <td>
        <div className="row g-0">
            <div className="col-md-4">
            <img src={product.productImg} className="img-fluid rounded-start" alt="..." />
            </div>
            <div className="col-md-8">
            <div className="card-body">
                <h5 className="card-title">{product.productName}</h5>
                <p className="card-text">
                {product.productManufacture} <br />
                {product.productSummary}
                </p>
            </div>
            </div>
        </div>
        </td>
        {/*<td>{products.productCategory}</td>*/}
        <td style={{textAlign: textPosition}}>
        {/*}<font color="lightgray"><s>4,000</s><br /></font>*/}
        {product.productPrice?.toLocaleString()}
        <br />
        x{product.productQuantity}
        <br />
        {(product.productQuantity * product.productPrice)?.toLocaleString()}
        </td>
        <td style={{textAlign: textPosition}}>
        <div className="d-grid gap-2 mt-3">
            <button className="btn btn-primary" type="button">-1</button>
        </div>
        <div className="d-grid gap-2 mt-3">
            <button className="btn btn-primary" type="button">+1</button>
        </div>                        
        </td>
        </tr>
    );
    }else{
        return (
            <tr key={product.productIdx}>
                <td>
                    {product.productName} <code>{product.productManufactureNickname}</code>
                    <p className="card-text">
                    <b>￥{product.productPrice?.toLocaleString()}</b> ({product.productPoint?.toLocaleString()} point)
                    </p>
                </td>
                {/*<td>{products.productCategory}</td>*/}
                <td style={{textAlign: textPosition}}>
                    {/*<input type="number" className="form-control" name="spQuantity" onChange={chkQuantity} value={product.spQuantity} defaultValue={product.spQuantity} />*/}
                    {/*<input type="number" className="form-control" name="salesProductQuantity" onChange={chkQuantity} value={product.salesProductQuantity} />*/}
                    {product.salesProductQuantity}
                </td>
                <td style={{textAlign: textPosition}}>
                  ￥{(product.salesProductQuantity * product.productPrice)?.toLocaleString()}
                </td>
            </tr>

        );
    }
}

export default PosContentsProduct;